export default __webpack_public_path__ + "static/media/icon_user_active.57a5c812.svg";